import type { RegionConfig } from './region/types'

// Host-independent data shared by both products without initializing B2C APIs.
export const regionalDefaults: Record<
  GLOBALS.Region,
  Pick<RegionConfig, 'currencyCode' | 'callingCodes'>
> = {
  CZ: { currencyCode: 'CZK', callingCodes: ['+420', '+421'] },
  PL: { currencyCode: 'PLN', callingCodes: ['+48'] },
}
